import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Drawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { TextField } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import AddIcon from "@mui/icons-material/Add";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import config from "../config.js";
import Layout from "../components/layout/Layout";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import RemoveIcon from "@mui/icons-material/Remove";
import { useCookies } from "react-cookie";
import GetUserFiles from "../components/GetUserFiles.jsx";

const UploadFiles = () => {
  const [data, setData] = useState("");

  const [cookie] = useCookies(["token", "userId"]);
  const { API_BASE_URL } = config;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleDownloadClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDownloadOptionClick = (option) => {
  
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (e) => {
    setData(e.target.value);
  };

  const submitData = async () => {
    const userId = cookie.userId;
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/v1/updateUploadFile`,
        { data, userId },
        {
          headers: {
            Authorization: `Bearer ${cookie.token}`,
          },
        }
      );
   
    } catch (error) {
      
    }
  };

  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <div>
      <Layout>
        <Box
          sx={{
            position: "fixed",
            top: 0,
            right: 0,
            m: 5,
            zIndex: 1300,
          }}
        >
          <ButtonGroup
            sx={{
              marginTop: 3,
              marginLeft: 7,
              justifyItems: "center",
              backgroundColor: "#FD6262",
            }}
            variant="contained"
            aria-label="Basic button group"
          >
            <Button
              sx={{
                backgroundColor: "#FD6262",
                display: "flex",
                justifyItems: "center",
                alignItems: "center",
                "&:hover": { backgroundColor: "#FF4D4D" },
              }}
            >
              <RemoveIcon />
            </Button>
            <Button
              sx={{
                backgroundColor: "#FD6262",
                "&:hover": { backgroundColor: "#FF4D4D" },
              }}
            >
              <AddIcon />
            </Button>
            <Button
              sx={{
                backgroundColor: "#FD6262",
                "&:hover": { backgroundColor: "#FF4D4D" },
              }}
              onClick={handleDownloadClick}
            >
              <ArrowCircleDownIcon />
            </Button>
            <Button
              sx={{
                backgroundColor: "#FD6262",
                "&:hover": { backgroundColor: "#FF4D4D" },
              }}
              onClick={handleDrawerToggle}
            >
              <RemoveRedEyeIcon />
            </Button>
          </ButtonGroup>
        </Box>
        <Drawer
          variant="persistent"
          anchor="right"
          open={isDrawerOpen}
          sx={{
            width: "20%",
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: "20%",
              boxSizing: "border-box",
            },
          }}
        >
          <Box p={2}>
            <Typography sx={{ marginTop: "60px" }} variant="h6"></Typography>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={() => handleDownloadOptionClick("CSV")}>
                CSV
              </MenuItem>
              <MenuItem onClick={() => handleDownloadOptionClick("PDF")}>
                PDF
              </MenuItem>
              <MenuItem onClick={() => handleDownloadOptionClick("Excel")}>
                Excel
              </MenuItem>
            </Menu>
            <Container className="side-panel">
              <div style={{ marginTop: "20px" }}>
                <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
                  <li style={{ marginBottom: "10px", fontWeight: "bold" }}>
                    Outliers
                  </li>
                  <li style={{ marginBottom: "10px", fontWeight: "bold" }}>
                    Highlights
                  </li>
                  <li style={{ marginBottom: "10px", fontWeight: "bold" }}>
                    RGY
                  </li>
                  <li style={{ marginBottom: "10px", fontWeight: "bold" }}>
                    Actions
                  </li>
                  <li style={{ marginBottom: "10px", fontWeight: "bold" }}>
                    Trends
                  </li>
                  <li
                    style={{
                      marginBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "bold",
                    }}
                  >
                    Projections
                    <TextField
                      sx={{ marginLeft: "10px" }}
                      variant="outlined"
                      value={data}
                      onChange={handleChange}
                      placeholder="Enter data"
                    />
                  </li>
                </ul>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "20px",
                  }}
                >
                  <Button
                    sx={{ backgroundColor: "#FD6262" }}
                    onClick={submitData}
                    variant="contained"
                  >
                    Submit
                  </Button>
                </div>
              </div>
              <div>
                <h3>Downloads</h3>
                <GetUserFiles userId={cookie.userId} />
              </div>
              <div>
                <h5>Chat</h5>
                <p>Internal chat component could be here.</p>
              </div>
            </Container>
          </Box>
        </Drawer>
      </Layout>
    </div>
  );
};

export default UploadFiles;
